import { render, staticRenderFns } from "./colonne_nom.vue?vue&type=template&id=22285d31"
import script from "./colonne_nom.js?vue&type=script&lang=js&external"
export * from "./colonne_nom.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports